import * as React from 'react';
import './menu.module.scss';
import { scrollToAnchor } from '../../../utils/scroll';
import { viewportState } from '../../../../commonv2/states/globalStates';
import { observer } from 'mobx-react';

const ITEMS = [
    { id: 'overview', label: 'イベント概要' },
    { id: 'coaches', label: '講師紹介' },
    // { id: 'voices', label: '体験者の声' },
    // { id: 'scenes', label: 'レッスンの様子' },
];

const SP_ITEMS = [{ id: 'overview', label: 'イベント概要' }, { id: 'coaches', label: '講師紹介' }];

@observer
export class Menu extends React.Component {
    render() {
        const items = viewportState.isMobile ? SP_ITEMS : ITEMS;
        return (
            <div styleName="container">
                <div styleName="list">
                    {items.map((item) => {
                        return (
                            <div key={item.id} styleName="item" onClick={() => scrollToAnchor(item.id)}>
                                {item.label}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
